import React, { useContext} from 'react';
import { Context_UI } from '../../Contexts/Context_UI';
import FullCalendar from "@fullcalendar/react";
import interactionPlugin from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid";
import { useAuth } from '../../Contexts/AuthContext';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';


export default function Tab_ScheduleManagement_Calendar({ Schedules, Room, InitialView }) {
    const { Account, Loading, Logout } = useAuth();
    const { Panel_Right_State, Panel_Toggle } = useStatus();
    const { Schedule_Display, Reservation_Set, Reservation_Default } = useScheduleManagement();
    const UI = useContext(Context_UI);
    const Events = Schedules.map(Schedule => ({
        id: Schedule._id,
        title: Schedule.Name,
        start: Schedule.Time.Start,
        end: Schedule.Time.End,
        extendedProps: {
            RoomID: Schedule.RoomID,
            Description: Schedule.Description
        }
    }));

    const Handle_Click = async (Information) => {
        // console.log(Information.event._def.publicId);
        await Schedule_Display(Information.event._def.publicId);
        if (Panel_Right_State == "Collapsed") {
            Panel_Toggle("Right");
        }
    }

    const Handle_Date = async (Information) => {
        const Start = new Date(Information.dateStr);
        const End = new Date(Start.getTime() + 60 * 60 * 1000);
        Reservation_Set(Previous => ({
            ...Reservation_Default,
            RoomID: Room || "",
            Time: {
                Start: Start,
                End: End
            },
            DateCreated: new Date(),
            DateModified: new Date()
        }));
        UI.Subwindows_Open("Window_ScheduleManagement_Reserve");
    }
    return (

        <div className='SM_Calendar'>
            <FullCalendar
                plugins={[dayGridPlugin, interactionPlugin]}
                initialView={InitialView == "Month" ? "dayGridMonth" :
                    InitialView == "Week" ? "dayGridWeek" :
                        InitialView == "Day" ? "dayGridDay" :
                            "dayGridMonth"
                }
                headerToolbar={{
                    left: "title",
                    center: "",
                    right: "prev next today"
                }}
                selectable={true}
                editable={false}
                events={Events}
                height="auto"
                eventClick={Handle_Click}
                dateClick={(Info) => Handle_Date(Info)}
            />
        </div>
    );
}
